<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Nuevo empleado</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
                >Volver</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <form
              ref="profile_form"
              @submit.prevent="handleSubmit"
              novalidate="true"
            >
              <div class="row">
                <div class="col-lg-3">
                  <div v-if="image" class="profile-image end">
                    <img
                      :src="`${image}`"
                      class="profile-image argon-image border-0"
                      width="200"
                    />
                  </div>
                  <div v-else class="profile-image end">
                    <img
                      src="/img/placeholder.png"
                      class="profile-image argon-image border-0"
                      width="200"
                    />
                  </div>
                  <div class="image-upload end">
                    <base-button
                      v-if="image"
                      type="button"
                      class="btn btn-sm btn-danger"
                      @click="removeImage"
                    >
                      <span>
                        <i class="fa fa-times" />
                        Eliminar
                      </span>
                    </base-button>
                    <base-button
                      type="button"
                      class="btn btn-sm btn-neutral px-4 ml-3"
                    >
                      <label v-if="!image" for="imageInput" class="mb-0"
                        >Seleccionar imagen</label
                      >
                      <label v-else for="imageInput" class="mb-0"
                        >Cambiar</label
                      >
                      <input
                        id="imageInput"
                        ref="imageInput"
                        accept="image/*"
                        type="file"
                        style="display: none"
                        @change="onSelectFile"
                      />
                    </base-button>
                  </div>
                </div>

                <div class="col-lg-9">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="Nombre*"
                        placeholder="Nombre"
                        type="text"
                        v-model="user.nombre"
                      />
                      <validation-error :errors="apiValidationErrors.nombre" />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Apellidos*"
                        placeholder="Apellidos"
                        type="text"
                        v-model="user.apellidos"
                      />
                      <validation-error
                        :errors="apiValidationErrors.apellidos"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="Email"
                        placeholder="Email"
                        v-model="user.email"
                      />
                      <validation-error :errors="apiValidationErrors.email" />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Teléfono"
                        placeholder="Teléfono"
                        v-model="user.telefono"
                      />
                      <validation-error
                        :errors="apiValidationErrors.telefono"
                      />
                    </div>
                    <!--  <div class="col-lg-6">
                      <base-input
                        label="Nombre de usuario"
                        placeholder="Nombre"
                        v-model="user.username"
                      />
                      <validation-error
                        :errors="apiValidationErrors.username"
                      />
                    </div> -->
                  </div>

                  <!--  <div class="row">
                    <div class="col-lg-6">
                      <base-input label="Planta">
                        <el-select name="empresa" v-model="user.empresas.id">
                          <el-option
                            v-for="empresa in available_empresas"
                            :key="empresa.id"
                            :value="empresa.id"
                            :label="empresa.alias"
                          >
                          </el-option>
                        </el-select>
                      </base-input>
                      <validation-error
                        :errors="apiValidationErrors.empresas"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Teléfono"
                        placeholder="Teléfono"
                        v-model="user.telefono"
                      />
                      <validation-error
                        :errors="apiValidationErrors.telefono"
                      />
                    </div>
                  </div> -->
                </div>
              </div>

              <div class="my-2 text-right">
                <base-button
                  type="button"
                  class="btn btn-primary"
                  native-type="submit"
                >
                  Crear empleado
                </base-button>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import { BasePagination } from "@/components/";
import {
  Table,
  TableColumn,
  Dialog,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import { cloneDeep } from "lodash";
moment.locale("es");

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";

export default {
  layout: "DashboardLayout",
  components: {
    BaseInput,
    BaseButton,
    ValidationError,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dialog.name]: Dialog,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },
  mixins: [formMixin],

  data() {
    return {
      image: null,
      file: null,
      available_empresas: [],
      user: {
        type: "users",
        username: null,
        email: null,
        nombre: null,
        apellidos: null,
        profile_image: null,
        imagen_perfil: null,
        activo: null,
        blocked: null,
        confirmed: null,
        cif: null,
        estado_usuario: null,
        telefono: null,
        /*  relationshipNames: ["roles"], */
        empresas: [
          {
            type: "empresas",
            id: 0,
          },
        ],
        /*   role: [
          {
            type: "roles",
            id: 4,
          },
        ], */
      },
      query: null,
      activos: [],
      selectedRows: [],
      sort: "fecha_prox_revision",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },
      multipleSelection: [],
      total: 0,
      loading: true,
      dialogFormVisible: false,
      dialogConfirmVisible: false,
      innerVisible: false,
      formLabelWidth: "120px",
      available_revisores: [],

      usuario: null,

      totalIncidencia: 0,
      totalCaducados: 0,
      totalCaducan: 0,
      totalAptos: 0,
      totalActivos: 0,
    };
  },
  created() {
    this.getEmpresas();
  },
  computed: {
    /*   from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    plantaSelected() {
      return this.$plantaSelected;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    }, */
  },
  watch: {},

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    refresh() {
      this.$router.go();
    },
    removeImage() {
      this.image = null;
    },

    validEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    async handleSubmit() {
      console.log("ENTRA en AddUserPage");

      if (!this.user.nombre) {
        this.$notify({
          type: "danger",
          message: `El nombre es obligatorio.`,
        });
        return;
      }
      if (!this.user.apellidos) {
        this.$notify({
          type: "danger",
          message: `El campo apellidos es obligatorio.`,
        });
        return;
      }
      if (!this.user.email) {
        /* this.$notify({
          type: "danger",
          message: `El correo electrónico es obligatorio`,
        });
        return; */
        var planta = localStorage.getItem("plantaSelected");
        console.log("PLANTA: ", planta);

        this.user.email =
          (this.user.nombre + " " + this.user.apellidos)
            .normalize("NFD") // Descompone los caracteres con acento
            .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
            .replace(/\s+/g, "") // Elimina todos los espacios en blanco
            .toLowerCase() +
          "_" +
          planta +
          "@misepis.com";
        console.log(this.user.email);
      }
      if (!this.validEmail(this.user.email)) {
        this.$notify({
          type: "danger",
          message: `El correo electrónico introducido no es válido`,
        });
        return;
      }

      this.user.role = {
        disconnect: [],
        connect: [{ id: 4, position: { end: true } }],
      };

      //this.user.empresas = [{ id: this.user.empresas.id }];
      this.user.empresas = planta;
      this.user.username =
        (this.user.nombre + " " + this.user.apellidos)
          .normalize("NFD") // Descompone los caracteres con acento
          .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
          .replace(/\s+/g, "") // Elimina todos los espacios en blanco
          .toLowerCase() +
        "_" +
        planta; // Convierte el número a string
      this.user.password = "Salvad0rM1s3p1s";
      this.user.password_confirmation = "Salvad0rM1s3p1s";

      this.user.estado_usuario = { id: 2 };

      this.user.activo = true;
      this.user.tipo_cuenta = 1;
      if (this.file) {
        console.log(this.file);
        await this.$store.dispatch("items/upload", {
          item: this.tipo,
          image: this.file,
        });

        this.user.imagen_perfil = await this.$store.getters["items/url"];
      }

      console.log("CONDE DIU: user");
      console.log(this.user);
      try {
        await this.$store.dispatch("users/add", this.user);

        var filters = {
          $and: [
            {
              email: { $eq: this.user.email },
            },
            /*  {
            role: {
              id: { $in: 4 },
            },
          }, */
            { $or: [] },
          ],
        };

        let params = {
          filters: filters,
          pagination: {
            page: 1,
            pageSize: 5,
          },
        };

        await this.$store.dispatch("users/list", params).then(async () => {
          var items = this.$store.getters["users/list"];

          console.log(items.length);

          if (items.length > 0) {
            var invitacion = {
              type: "invitacions",
              titulo: "Usuario creado desde admin",
              descripcion: "",

              usuarios: [
                {
                  type: "users",
                  id: items[0].id,
                },
              ],
            };

            console.log("CONDE DIU: invitacion");
            console.log(invitacion);

            await this.$store.dispatch("invitacions/add", invitacion);

            this.$notify({
              type: "success",
              message: "Empleado creado correctamente.",
            });
            this.goBack();
          }
        });

        /*   this.$notify({
          type: "success",
          message: "Empleado añadido correctamente.",
        }); */
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
        console.log("CONDE DIU: error");
        console.log(error);
        console.log(error.response.data.error);
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },

    async onSelectFile(e) {
      let files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.file = file;
      };
      reader.readAsDataURL(file);
    },

    async getEmpresas() {
      try {
        await this.$store.dispatch("profile/me");
        let me = await this.$store.getters["profile/me"];

        me.empresas.forEach((element) => {
          this.available_empresas.push(element);
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
    /*
    getRoles() {
      try {
        this.$store.dispatch("roles/list").then(() => {
          this.available_roles = cloneDeep(
            this.$store.getters["roles/dropdown"]
          );
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
        this.setApiValidation(error.response.data.errors);
      }
    }, */

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `${prop}:desc`;
      } else {
        this.sort = `${prop}:asc`;
      }
      this.getList();
    },
  },
};
</script>
